"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _LayoutGrid = _interopRequireDefault(require("./LayoutGrid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "relative",
    padding: props => {
      return theme.spacing(props.padding);
    },
    "& > * + *": {
      marginTop: props => {
        return theme.spacing(props.spacing);
      }
    }
  }
}));

const LayoutBody = ({
  grid = false,
  padding,
  spacing,
  children
}) => {
  const classes = useStyles({
    padding,
    spacing
  });

  if (!children) {
    return false;
  }

  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement(_LayoutGrid.default, {
    grid: grid,
    padding: padding,
    spacing: spacing
  }, children));
};

var _default = LayoutBody;
exports.default = _default;
module.exports = exports.default;